import type { Theme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { ImageSanity } from '~/components/atoms/ImageSanity';
import type { ImageSanityWrapperProps } from './ImageSanityWrapper.types';

const IMAGE_WIDTHS = {
  mobile: { small: '50%', medium: '100%', large: '100%' },
  desktop: { small: '25%', medium: '50%', large: '100%' },
};

export const ImageSanityWrapper = ({ imageDesktop, imageMobile, size = 'large', testId }: ImageSanityWrapperProps) => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));

  // If imageMobile is not provided, fallback to imageDesktop
  const currentImage = isMobile && imageMobile ? imageMobile : imageDesktop;
  const width = IMAGE_WIDTHS[isMobile ? 'mobile' : 'desktop'][size];

  // Use aspect ratio from Sanity metadata to prevent layout shift before image loads
  const aspectRatio = currentImage.metadata?.dimensions?.aspectRatio;

  return (
    <ImageSanity
      imageObject={currentImage}
      testId={testId}
      styles={{
        width,
        height: 'auto',
        aspectRatio,
      }}
    />
  );
};
